export default "__VITE_PUBLIC_ASSET__8c2c954d__"